import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-04741430")

_pushScopeId("data-v-04741430")
const _hoisted_1 = { class: "display-flex align-items-center margin-top10px" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")

  return (_openBlock(), _createBlock("div", null, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.planItem.Plan, (itemForPlan, index) => {
      return (_openBlock(), _createBlock("div", {
        key: itemForPlan.ID,
        class: "margin-top10px"
      }, [
        _createVNode(_component_cus_select, {
          width: "300px",
          disabled: itemForPlan.FeaturePlanType ? true : false,
          placeholder: _ctx.$wordList.ProperAllTextPlan,
          modelValue: itemForPlan.ID,
          "onUpdate:modelValue": ($event: any) => (itemForPlan.ID = $event)
        }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options.Plan, (item) => {
              return (_openBlock(), _createBlock(_component_cus_option, {
                key: item,
                label: `${item.Name}-${item.ID}`,
                value: item.ID,
                disabled: _ctx.choosePlan.includes(item.ID)
              }, null, 8, ["label", "value", "disabled"]))
            }), 128))
          ]),
          _: 2
        }, 1032, ["disabled", "placeholder", "modelValue", "onUpdate:modelValue"]),
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_cus_select, {
            width: "300px",
            disabled: _ctx.editFee ? false : (itemForPlan.FeaturePlanType?true:false),
            placeholder: _ctx.$wordList.Fee,
            modelValue: _ctx.planItem.Fee[index].UUID,
            "onUpdate:modelValue": ($event: any) => (_ctx.planItem.Fee[index].UUID = $event)
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options.Fee, (item) => {
                return (_openBlock(), _createBlock(_component_cus_option, {
                  key: item,
                  label: `${item.FeatureName}-${item.ID}`,
                  value: item.UUID
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 2
          }, 1032, ["disabled", "placeholder", "modelValue", "onUpdate:modelValue"]),
          (!itemForPlan.FeaturePlanType)
            ? (_openBlock(), _createBlock("i", {
                key: 0,
                class: "delete-icon el-icon-my-remove margin-left15px",
                onClick: ($event: any) => (_ctx.remove(index))
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128))
  ]))
})